import React from 'react';
import './reset.css';
import ReactDOM from 'react-dom/client';
import './variables.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <App />
  </>
);
